<template>
    <div class="system-health">
        <div>{{ $t("dashboard.system_health") }}</div>
        
        <div style="height:300px" ref="chartdiv">
        </div>
        <el-tooltip :content="$t(`dashboard.diffPreviousPeriod`)" placement="top">

<el-badge :value="` ${(healthDiff)} %`" class="previous-fault" v-if="this.healthDiff < 0" type="danger">
</el-badge>
<el-badge :value="` ${(healthDiff)} %`" class="previous-fault" v-if="this.healthDiff >= 0" type="success">
</el-badge>
<em class="el-icon-info"></em>
</el-tooltip>
    </div>
</template>
  
<script>
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import axios from 'axios';
import colorLib from '../../util/colorLib';
import dayjs from 'dayjs';

export default {
    name: 'SystemHealth_PieChart',
    props: {
        startDate: {
            type: String
        },
        endDate: {
            type: String
        },
        unit: {
            type: String
        },
        interval: {
            type: Object
        },
    },
    data() {
        return {
            series: [],
            health: 100,
            previousHealth: 100,
            healthDiff: 0,
            points: {
                type: Array,
                default() {
                    return [];
                },
            },
        };
    },
    methods: {
        setColor(health) {
            this.series.get("colors").set("colors", [
                am5.color(colorLib.getRiskColor(health)),
                am5.color(0xe2e2e2)
            ]);
        },

        async getPreviousHealth() {
            const previousStart = dayjs().subtract(this.interval.hours * 2, 'hour').format('YYYY-MM-DDTHH:mm:ss');
            var urlString = `${process.env.VUE_APP_APIURL}/dashboard/system-health`;
            var params = {
                params: {
                    start: previousStart, end: this.startDate, unit: this.unit
                }
            };
            let resp = await axios
                .get(urlString, params);
            if (resp.status == 200) {
                if (resp.data) {
                    this.previousHealth = resp.data.health.toFixed(2);
                }
                else {
                    this.previousHealth = 100;
                }
            }
            else {
                console.log("Error loading data");
            }
            this.healthDiff = (this.health - this.previousHealth).toFixed(2);
        },
        async loadData() {
            var urlString = `${process.env.VUE_APP_APIURL}/dashboard/system-health`;
            var params = {
                params: {
                    start: this.startDate, end: this.endDate, unit: this.unit
                }
            };

            let resp = await axios
                .get(urlString, params);
            if (resp.status == 200) {
                if (resp.data) {
                    const health = resp.data.health;
                    const total = 100 - health;
                    this.health = health;
                    this.setColor(health);
                    this.series.data.setAll([
                        { sector: "healthy", size: health },
                        { sector: "total", size: total }
                    ]);
                    this.label.set("text", `${health.toFixed(2)}%`);
                }
                else {
                    const total = 0;
                    const health = 100;
                    this.health = health;
                    this.setColor(health);
                    this.series.data.setAll([
                        { sector: "healthy", size: health },
                        { sector: "total", size: total }
                    ]);
                    this.label.set("text", `${health.toFixed(2)}%`);
                }
            } else {
                console.log("Error loading data");
            }


            this.getPreviousHealth();
        }
    },
    mounted() {

        let root = am5.Root.new(this.$refs.chartdiv);

        root.setThemes([am5themes_Responsive.new(root)]);

        let chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                innerRadius: am5.percent(80),
                radius: am5.percent(75),
                layout: root.verticalLayout
            })
        );

        let series = [];
        // Create series
        series = chart.series.push(
            am5percent.PieSeries.new(root, {
                valueField: "size",
                categoryField: "sector"
            })
        );

        this.series = series;

        series.labels.template.set('forceHidden', true);
        series.ticks.template.set('forceHidden', true);

        let label = root.tooltipContainer.children.push(
            am5.Label.new(root, {
                x: am5.p50,
                y: am5.p50,
                centerX: am5.p50,
                centerY: am5.p50,
                fill: am5.color(0x000000),
                fontSize: 25,
            })
        );

        this.label = label;

        this.loadData();
    },

    beforeDestroy() {
        if (this.root) {
            this.root.dispose();
        }
    },
    watch: {
        deep: true,
        startDate: function () {
            this.loadData();
        },
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.system-health {
    position: relative;
}

.previous-fault {
    position: absolute;
    right: 10px;
    bottom: 5px;
}

.hello {
    width: 100%;
    height: 500px;
}
</style>